
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import ParkingSpotCard from "@/components/search/ParkingSpotCard";
import { useToast } from "@/components/ui/use-toast";

interface ParkingSpot {
  id: string;
  owner_id: string;
  owner_name: string;
  address: string;
  vehicle_type: string;
  security_type: string;
  price_per_hour: number;
  parking_lot_count: number;
  images: string[];
  is_available: boolean;
}

const MyListings = () => {
  const [spots, setSpots] = useState<ParkingSpot[]>([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    const fetchMySpots = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;

        const { data, error } = await supabase
          .from("parking_spots")
          .select("*")
          .eq("owner_id", user.id);

        if (error) throw error;
        setSpots(data || []);
      } catch (error: any) {
        toast({
          title: "Error",
          description: error.message,
          variant: "destructive",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchMySpots();
  }, [toast]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">My Parking Spots</h1>
      {spots.length === 0 ? (
        <p>You haven't listed any parking spots yet.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {spots.map((spot) => (
            <ParkingSpotCard
              key={spot.id}
              spot={spot}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MyListings;
